import { render, staticRenderFns } from "./TariffSelector.vue?vue&type=template&id=046b0217&scoped=true"
import script from "./TariffSelector.vue?vue&type=script&lang=js"
export * from "./TariffSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046b0217",
  null
  
)

export default component.exports